import unescapedText from 'I18n/utils/unescapedText';
import { useMemo } from 'react';
import { useLocation } from 'quartz-routing/react-router';
import { Paths } from '../../constants/paths';
import { usePartnerTierIconMap } from '../../utils/getPartnerTierContent';
import { getFlattenedOptions } from '../filterUtils';
import { useAppliedFilters } from './useAppliedFilters';
import { useAsyncFilterOptions } from './useAsyncFilterOptions';
export function useFilterTags() {
  const appliedFilters = useAppliedFilters();
  const location = useLocation();
  const partnerTierIconMap = usePartnerTierIconMap();
  const asyncFilterOptionsResult = useAsyncFilterOptions();
  const filterTags = useMemo(() => {
    const tags = [];
    for (const appliedFilter of appliedFilters) {
      var _asyncFilterOptionsRe, _asyncFilterOptionsRe2;
      if (appliedFilter.field === 'PRODUCT_TYPE' && (location.pathname === Paths.SEARCH_RESULTS || location.pathname === Paths.SEARCH_RESULTS_PRODUCTS)) {
        continue;
      }

      // Special handling for language filters
      if (appliedFilter.field === 'APP_LANGUAGES' || appliedFilter.field === 'PROFILE_LANGUAGES') {
        tags.push(...appliedFilter.values.map(value => {
          var _ref, _appliedFilter$label, _ref2, _appliedFilter$label2;
          return {
            field: appliedFilter.field,
            text: unescapedText('marketplaceStorefront.filters.filterChip', {
              label: (_ref = (_appliedFilter$label = appliedFilter.label) !== null && _appliedFilter$label !== void 0 ? _appliedFilter$label : appliedFilter.placeholder) !== null && _ref !== void 0 ? _ref : '',
              value: unescapedText(`SharedI18nStrings.languageNames.${value}`)
            }),
            tooltip: (_ref2 = (_appliedFilter$label2 = appliedFilter.label) !== null && _appliedFilter$label2 !== void 0 ? _appliedFilter$label2 : appliedFilter.placeholder) !== null && _ref2 !== void 0 ? _ref2 : '',
            value
          };
        }));
        continue;
      }
      const asyncOptions = (_asyncFilterOptionsRe = (_asyncFilterOptionsRe2 = asyncFilterOptionsResult.data) === null || _asyncFilterOptionsRe2 === void 0 ? void 0 : _asyncFilterOptionsRe2.result.filterOptions[appliedFilter.field]) !== null && _asyncFilterOptionsRe !== void 0 ? _asyncFilterOptionsRe : [];

      // Flatten the options if necessary
      const options = appliedFilter.hasMoreOptions ? asyncOptions : getFlattenedOptions(appliedFilter);

      // Async filter still loading? Just hide
      if (appliedFilter.hasMoreOptions && options.length === 0) continue;

      // Toggle filters, such as Installable, Breeze, and Certified, have no options
      if (options.length === 0) {
        var _ref3, _appliedFilter$label3;
        tags.push({
          field: appliedFilter.field,
          text: (_ref3 = (_appliedFilter$label3 = appliedFilter.label) !== null && _appliedFilter$label3 !== void 0 ? _appliedFilter$label3 : appliedFilter.placeholder) !== null && _ref3 !== void 0 ? _ref3 : '',
          value: appliedFilter.values[0],
          // Don't show a tooltip for toggle filters, as they are self-explanatory
          tooltip: ''
        });
        continue;
      }
      for (const option of options) {
        if (appliedFilter.values.includes(option.value)) {
          var _ref4, _appliedFilter$label4, _ref5, _appliedFilter$label5;
          tags.push({
            field: appliedFilter.field,
            icon: appliedFilter.field === 'PROFILE_SOLUTIONS_PARTNER_TIER' ? partnerTierIconMap === null || partnerTierIconMap === void 0 ? void 0 : partnerTierIconMap[option.value] : undefined,
            text: unescapedText('marketplaceStorefront.filters.filterChip', {
              label: (_ref4 = (_appliedFilter$label4 = appliedFilter.label) !== null && _appliedFilter$label4 !== void 0 ? _appliedFilter$label4 : appliedFilter.placeholder) !== null && _ref4 !== void 0 ? _ref4 : '',
              value: option.text
            }),
            tooltip: (_ref5 = (_appliedFilter$label5 = appliedFilter.label) !== null && _appliedFilter$label5 !== void 0 ? _appliedFilter$label5 : appliedFilter.placeholder) !== null && _ref5 !== void 0 ? _ref5 : '',
            value: option.value
          });
        }
      }
    }
    return tags;
  }, [appliedFilters, asyncFilterOptionsResult.data, location.pathname, partnerTierIconMap]);
  return filterTags;
}